import * as React from 'react';

import { OrganizationNotificationType } from 'ab-enums/organizationNotificationType.enum';

import { ORGANIZATION_WEEKLY_REVENUE_TIME_SETTINGS } from 'af-constants/reduxForms';

import Description from './Description';
import EmailList from '../NotificationSettingsForms/EmailList';
import NotificationTimeSettings from '../NotificationSettingsForms/NotificationTimeSettings';

const notificationType = OrganizationNotificationType.WEEKLY_REVENUE;

const NotificationSettingsForms: React.FC = () => {

	return (
		<div className="form-box">
			<Description />
			<NotificationTimeSettings formType={ORGANIZATION_WEEKLY_REVENUE_TIME_SETTINGS} notificationType={notificationType}/>
			<EmailList notificationType={notificationType}/>
		</div>
	);
};

export default React.memo(NotificationSettingsForms);
